// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Results_wrapper__j1ip-"};